import IssueCertificate from './IssueCertificate'

export default IssueCertificate
